let {Date} = window
const getCurrentTimeSecond = () => {
  return Date.parse(new Date()) / 1000
}
export const timeUtil = {getCurrentTimeSecond}
